import {ChangeDetectorRef, Directive, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {RANGE_DATE_CONTROLLER} from "./range-date-controller.token";
import {DestroyStreamService} from "../../../../../services";
import {takeUntil} from "rxjs/operators";

@Directive({
  selector: '[intRangeDateController], int-range-calendar',
  providers: [
    DestroyStreamService
    // {
    //   provide: RANGE_DATE_CONTROLLER,
    //   useClass: forwardRef(() => RangeDateControllerDirective),
    //   multi: true
    // }
  ]
})
export class RangeDateControllerDirective implements OnInit, OnChanges {

  @Input() dateRange: [Date | null, Date | null] = [null, null];

  range$: BehaviorSubject<[Date | null, Date | null]>
    = new BehaviorSubject<[(Date | null), (Date | null)]>([null, null]);

  change$: Subject<[Date | null, Date | null]> = new Subject();

  @Output() onChange = new EventEmitter<[Date | null, Date | null]>();

  constructor(
    private readonly destroy$: DestroyStreamService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.range$
      .pipe(takeUntil(this.destroy$))
      .subscribe((range) => {
        this.onChange.emit(range);
      })
  }

  ngOnInit() {
    this.range$.next(this.dateRange);
  }

  ngOnChanges() {
    this.change$.next(this.dateRange);
    this.cdr.markForCheck();
  }


  setFrom(date: Date) {
    this.range$.next([date, this.range$.value[1]])
  }

  setTo(date: Date) {
    this.range$.next([this.range$.value[0], date])
  }

}
